<template>
    <!-- TODO [P0] Need refactoring with remove component is -->
    <component
        :is="card ? 'v-card' : 'div'"
        v-if="info.checkInFrom || info.checkInTo || info.checkOutFrom || info.checkOutTo"
        outlined
        class="hotel-info-time d-flex flex-column text-black text-caption"
        :class="{'pt-3 px-4': card}"
    >
        <v-divider v-if="!card" class="mb-3" />
        <v-row v-if="info.checkInFrom || info.checkInTo" class="hotel-info-time__row d-flex align-start" no-gutters>
            <v-col cols="4" class="hotel-info-time__title d-flex font-weight-bold">
                <v-icon class="me-2" size="small" color="black">mdi-clock-outline</v-icon>
                <div>{{ $t('earlyCheckInTitle') }}:</div>
            </v-col>
            <v-col cols="8" class="hotel-info-time__label d-flex flex-column flex-grow-1 font-weight-medium">
                <div class="ps-2 width-max-content">{{ checkInLabel }}</div>
                <v-range-slider
                    v-model="checkInRange"
                    :min="0"
                    :max="24"
                    density="compact"
                    color="primary"
                    track-size="2"
                    thumb-size="0"
                    hide-details
                    class="hotel-info-time__range"
                />
            </v-col>
        </v-row>
        <v-row v-if="info.checkOutFrom || info.checkOutTo" class="hotel-info-time__row d-flex align-start" no-gutters>
            <v-col cols="4" class="hotel-info-time__title d-flex font-weight-bold">
                <v-icon class="me-2" size="small" color="black">mdi-clock-outline</v-icon>
                <div>{{ $t('lateCheckOutTitle') }}:</div>
            </v-col>
            <v-col cols="8" class="hotel-info-time__label d-flex flex-column font-weight-medium flex-grow-1">
                <div class="ps-2">{{ checkOutLabel }}</div>
                <v-range-slider
                    v-model="checkOutRange"
                    :min="0"
                    :max="24"
                    density="compact"
                    color="primary"
                    track-size="2"
                    thumb-size="0"
                    hide-details
                    class="hotel-info-time__range"
                />
            </v-col>
        </v-row>
        <div class="mb-4">{{ $t('local_time') }}</div>
        <v-divider v-if="!card" />
    </component>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class HotelInfoTime extends Vue {
        @Prop({default: false, type: Boolean}) card

        get info() {
            return hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo
        }

        getRangeByKey(key) {
            const fromNumber = +this.info[`${key}From`]?.slice(0, 2) || 0
            const toNumber = +this.info[`${key}To`]?.slice(0, 2) || 24

            return [fromNumber, toNumber]
        }

        getLabelByKey(key) {
            let label

            if (!this.info[`${key}From`]) {
                label = `${this.$t('before')} ${this.info[`${key}To`]}`
            } else if (!this.info[`${key}To`]) {
                label = `${this.$t('after')} ${this.info[`${key}From`]}`
            } else {
                label = `${this.$t('tours.from')} ${this.info[`${key}From`]} ${this.$t('tours.to')} ${
                    this.info[`${key}To`]
                }`
            }

            return label[0].toUpperCase() + label.slice(1)
        }

        get checkInLabel() {
            return this.getLabelByKey('checkIn')
        }

        get checkOutLabel() {
            return this.getLabelByKey('checkOut')
        }

        get checkInRange() {
            return this.getRangeByKey('checkIn')
        }

        get checkOutRange() {
            return this.getRangeByKey('checkOut')
        }
    }

    export default HotelInfoTime
</script>

<style scoped lang="scss">
    :deep(.v-slider__thumb-container) {
        visibility: hidden;
    }

    :deep(.v-slider--horizontal .v-slider__track-container) {
        height: 3px;
    }
</style>
